// extracted by mini-css-extract-plugin
export default {"calendarIcon":"Anchor-module__calendarIcon--vmzmc"};